/* AlpineJS is our main JS utility framework, doc here : https://alpinejs.dev/start-here */
import Alpine from "alpinejs";

import BiggerPicture from "bigger-picture";

/* Common */
import { initAlpineJs } from "./common/Alpine.js";
import Slider from "./common/Slider";
import Anime from "./common/Anime";
import Archive from "./common/Archive";
import Anchors from "./common/Anchors";
import Sticky from "./common/Sticky";
import DecoMagnet from "./common/DecoMagnet";

/* Blocks */

const components = {
	sticky: {
		component: Sticky,
	},
	anime: { 
		component: Anime,
	},
	slider: {
		component: Slider,
	},
	anchors: {
		component: Anchors,
	},
	archive: {
		component: Archive,
	},
	deco: {
		component: DecoMagnet, 
	},
};

/**
 * Init Components
 */ 
const initComponents = () => {
	/* Init components */
	for (var [key, values] of Object.entries(components)) {
		const Component = values.component;

		if (values.active != false) {
			const elms = [...document.querySelectorAll(`[data-hwc-${key}]`)];
			if (elms.length) {
				elms.forEach((el) => {
					new Component(el);
				});
			} else if (values.force == true) {
				new Component();
			}
		}
	}
};

/**
 * Our document is ready
 */
document.addEventListener("DOMContentLoaded", () => {
	/* Starts Alpine */
	window.Alpine = Alpine;
	Alpine.start();

	/* Init anchors */
	const params = new URLSearchParams(window.location.search);
	const anchor = params.get("anchor");
	if (anchor) {
		const target = document.querySelector(`[data-anchors-section="${anchor}"]`);
		if (target) {
			setTimeout(() => {
				window.scrollTo({
					top: target.offsetTop,
					behavior: "smooth",
				});
			}, 200);
		}
	}

	/* Init Components */
	initComponents();

	/* Init gallery with bigger picture */
	if (typeof BiggerPicture === "function") {
		let bp = BiggerPicture({
			target: document.body,
		});

		if (document.querySelectorAll("[data-hwc-lightbox]").length) {
			document.querySelectorAll("[data-hwc-lightbox]").forEach((lightbox) => {
				const links = [...lightbox.querySelectorAll("[data-lightbox-link]")];
				for (let link of links) {
					link.addEventListener("click", (e) => {
						e.preventDefault();
						bp.open({
							items: links,
							el: e.currentTarget,
							intro: "fadeup",
							scale: 0.9,
						});
					});
				}
			});
		}
	}

	/* Adds class to body if it's domready */
	document.body.classList.add("is-domready");
});

/**
 * Our window is fully loaded
 */
window.addEventListener("load", () => {
	/* Adds class to body if it's loaded  */
	document.body.classList.add("is-loaded");
});

/**
 * Components instanciation
 */
document.addEventListener("alpine:init", () => {
	initAlpineJs();
});
